// src/colors.js
export const pinkGradient = 'linear-gradient(90deg, #f8c8dc, #c77dba, #e8a0bf, #f4b8d4, #c77dba)';

// Cute pastel palette used for icon chips, accents, and card highlights
export const pastels = {
  pink: '#f6a8c9',
  lavender: '#c9b6f0',
  sky: '#a8d0f0',
  mint: '#a8e0c8',
  peach: '#ffcfa3'
};
